import Loader from 'Components/Common/Loader';
import ifConfigured from 'hoc/ifConfigured';
import React, { useEffect, useState } from 'react'
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { enableMediaTracking as enableMediaTrackingAPI } from 'services/api/social-account';
import { fetchSocialAccountsThunk } from 'slices/auth/thunk';
import { toggleAddSocialAccountOffcanvas } from 'slices/ui/reducer';
import { AppDispatch, RootState } from 'store'
import { formatNumber, getErrorMessage, textToTitleCase } from 'utils/helpers';

const SocialAccounts = () => {

    const socialAccounts = useSelector((state: RootState) => state.auth.social_accounts.items);
    const socialAccountsLoading = useSelector((state: RootState) => state.auth.social_accounts.loading);
    const maxIGAccountsLimitRaw = useSelector((state: RootState) => state.auth.configurations.agency_max_ig_accounts);
    const maxYTAccountsLimitRaw = useSelector((state: RootState) => state.auth.configurations.agency_max_yt_accounts);
    const maxIGAccountsLimit = Number(maxIGAccountsLimitRaw ?? 1);
    const maxYTAccountsLimit = Number(maxYTAccountsLimitRaw ?? 1);
    const maxAllowedSocialAccounts = maxIGAccountsLimit + maxYTAccountsLimit;
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const [enablingIds, setEnablingIds] = useState<Set<string>>(new Set());


    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSocialAccountsThunk({ force: false }));
    }, [dispatch]);

    const enableMediaTracking = async (e: any, socialAccountId: string) => {
        if (!socialAccountId || !selectedAgencyId) return;
        try {
            setEnablingIds(prev => new Set(prev).add(socialAccountId));
            await enableMediaTrackingAPI(selectedAgencyId, socialAccountId);
            await dispatch(fetchSocialAccountsThunk({ force: true }))
            toast.success("Media tracking enabled!");
        } catch (error) {
            console.log('err', error);
            toast.error(getErrorMessage(error));
        } finally {
            setEnablingIds(prev => {
                const s = new Set(prev);
                s.delete(socialAccountId);
                return s;
            });
        }
    }

    if (socialAccountsLoading) {
        return <Loader />
    }

    return (
        <div className="page">
            <div className="page-heading">
                <div className="content pt-0 d-flex w-100 justify-content-between align-items-center">
                    <h4 className="page-title">Social Account</h4>
                    {
                        (socialAccounts.length < maxAllowedSocialAccounts) &&
                        <button className='btn btn-gradient d-flex gap-2 align-items-center' onClick={() => dispatch(toggleAddSocialAccountOffcanvas(true))}> <i className='mdi mdi-plus fs-5'></i> Add Account</button>
                    }
                </div>
            </div>
            <div className="content">
                <div className="row g-4" >
                    {
                        socialAccounts.map((account) => (
                            <div className="col-12" key={account.social_account.uuid}>
                                <div className="campaign-card-outer p-0" >
                                    <div>
                                        <div className="campaign-card mh-auto p-0">
                                            <div className="d-flex justify-content-between align-items-center h-100 flex-wrap flex-lg-fill">
                                                <div className="p-3 h-100 d-flex align-items-center">
                                                    <div className="d-flex gap-3">
                                                        <Link to={{ pathname: `/social-account/${account.social_account.uuid}` }}>
                                                            <div className="position-relative h-100">

                                                                {
                                                                    (account?.social_account?.profile_picture_url) ?
                                                                        (
                                                                            <div className="campaign-hero-img bg-image bgc-white" style={{ width: '130px', height: '130px', backgroundImage: `url(${account?.social_account?.profile_picture_url})`, border: '1px solid red' }}>
                                                                            </div>
                                                                        ) :
                                                                        (
                                                                            <Avatar size={"130px"} round={'6px'} name={account?.social_account?.ig?.name} maxInitials={1} />
                                                                        )
                                                                }
                                                                {
                                                                    account?.social_account?.platform === 'ig' &&
                                                                    <div className="ig-logo-space">
                                                                        <div className="ig-logo"></div>
                                                                    </div>
                                                                }
                                                                {
                                                                    account?.social_account?.platform === 'yt' &&
                                                                    <div className="ig-logo-space">
                                                                        <i className="ri-youtube-fill fs-16px text-danger"></i>
                                                                    </div>
                                                                }
                                                            </div>

                                                        </Link>

                                                        <div className="d-flex flex-column justify-content-between flex-wrap gap-3">
                                                            <div className="d-flex flex-column gap-1">
                                                                <h6 className="campaign-name m-0">
                                                                    {
                                                                        account?.social_account?.platform === 'ig' && account.social_account?.ig?.name
                                                                    }
                                                                    {
                                                                        account?.social_account?.platform === 'yt' && account.social_account?.yt?.title
                                                                    }
                                                                </h6>
                                                                <span className="published-at">@{account?.social_account?.handle}</span>
                                                                {
                                                                    account.status !== 'unverified' &&
                                                                    <div className="d-flex align-items-center gap-2 mt-2">
                                                                        <span className="badge language-badge">{textToTitleCase(account.status)}</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="d-flex campaign-actions gap-2 flex-wrap">
                                                                {
                                                                    account?.social_account?.platform === 'ig' &&
                                                                    <>
                                                                        {
                                                                            account?.status === 'unverified' &&
                                                                            <Link to={`/c/ig?social_account_id=${account.social_account.uuid}`} className="theme-btn theme-btn-md btn-primary-outlined">Connect</Link>
                                                                        }
                                                                        {
                                                                            account?.status === 'inactive' &&
                                                                            <Link to={`/c/ig?social_account_id=${account.social_account.uuid}`} className="theme-btn theme-btn-md btn-primary-outlined">Re-Connect</Link>

                                                                        }
                                                                        {
                                                                            <>
                                                                                {
                                                                                    account?.track_media?.status === 'active' &&
                                                                                    <Link to={`/track-media?social_account_id=${account.social_account.uuid}`} className="theme-btn theme-btn-md btn-primary-outlined">Track Media</Link>
                                                                                }
                                                                                {
                                                                                    (!account?.track_media || account?.track_media?.status === 'inactive') &&
                                                                                    <button onClick={(e) => enableMediaTracking(e, account.social_account.uuid)} className='theme-btn theme-btn-md btn-primary-outlined'>{enablingIds.has(account.social_account.uuid) ? "Please wait..." : "Enable Tracking"}</button>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    <div className="h-100 w-100 w-lg-50 w-xxl-35 border-top border-top-lg-none">
                                                        {
                                                            account?.social_account?.platform === 'ig' &&
                                                            <div className="row g-0 campaign-stats h-100 justify-content-end">
                                                                <div className="col-3 campaign-stat-item border-bottom-0 w-25">
                                                                    <span className="stat-value">{formatNumber(account?.social_account?.ig?.media_count ?? 0)}</span>
                                                                    <span className="stat-label">Posts</span>
                                                                </div>
                                                                <div className="col-3 campaign-stat-item border-bottom-0 w-25">
                                                                    <span className="stat-value">{formatNumber(account?.social_account?.ig?.followers_count ?? 0)}</span>
                                                                    <span className="stat-label">Followers</span>
                                                                </div>
                                                                <div className="col-3 campaign-stat-item border-bottom-0 w-25">
                                                                    <span className="stat-value">{formatNumber(Number(account?.social_account?.ig?.follows_count))}</span>
                                                                    <span className="stat-label">Following</span>
                                                                </div>
                                                                {/* <div className="col-3 campaign-stat-item border-bottom-0 w-25">
                                                                <span className="stat-value">{formatNumber(Number(account?.social_account?.engagement_score ?? 0))}</span>
                                                                <span className="stat-label">Engagement Score</span>
                                                            </div> */}
                                                            </div>
                                                        }
                                                        {
                                                            account?.social_account?.platform === 'yt' &&
                                                            <div className="row g-0 campaign-stats h-100 justify-content-end">
                                                                <div className="col-3 campaign-stat-item border-bottom-0 w-25">
                                                                    <span className="stat-value">{formatNumber(account?.social_account?.yt?.video_count ?? 0)}</span>
                                                                    <span className="stat-label">Videos</span>
                                                                </div>
                                                                <div className="col-3 campaign-stat-item border-bottom-0 w-25">
                                                                    <span className="stat-value">{formatNumber(account?.social_account?.yt?.subscriber_count ?? 0)}</span>
                                                                    <span className="stat-label">Subscribers</span>
                                                                </div>
                                                                <div className="col-3 campaign-stat-item border-bottom-0 w-25">
                                                                    <span className="stat-value">{formatNumber(Number(account?.social_account?.yt?.view_count))}</span>
                                                                    <span className="stat-label">Views</span>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    {
                        (socialAccounts.length === 0) &&
                        <>
                            <div className="col-xl-3 col-12">

                            </div>
                            <div className="col-xl-6 col-12">
                                <div className="d-flex w-100 justify-content-center align-items-center">
                                    <div className="length-zero d-flex align-items-center justify-content-center flex-column gap-2">
                                        <h3>Currently you have not connected any social account!</h3>
                                        {/* <Link className='btn btn-gradient d-flex gap-2 align-items-center' to={{ pathname: '/c/ig' }}> <i className='mdi mdi-instagram fs-5'></i> Connect Instagram</Link> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-12">

                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default SocialAccounts;
